import React, { useEffect } from 'react';

export type ClickOutsideProps = {
    ref: React.MutableRefObject<HTMLElement | null>;
    setIsToggled: React.Dispatch<React.SetStateAction<boolean>>;
};

export const useClickOutside = ({ ref, setIsToggled }: ClickOutsideProps) => {
    useEffect(() => {
        const listener = (event: MouseEvent) => {
            // Pulled from EDS Iconography
            const upIconChildId =
                'chevron-up-chunky_svg__eds-icon--chevron-up-chunky_base';
            const downIconChildId =
                'chevron-down-chunky_svg__eds-icon--chevron-down-chunky_base';
            const SVG_IDS_CHECK = [
                upIconChildId,
                downIconChildId,
                'upIcon',
                'downIcon',
            ];

            // Because we are changing which SVG we render everytime the dropdown is manipulated
            // we need to manually check if the click is on the SVG or the SVG's children
            // despite the SVG already being a child of the dropdown
            const OUTSIDE_CLICK =
                ref.current &&
                !ref.current.contains(event.target as Node) &&
                (event.target as Element)?.id !== upIconChildId &&
                (event.target as Element)?.id !== downIconChildId &&
                !SVG_IDS_CHECK.includes((event.target as Element)?.id);

            if (OUTSIDE_CLICK) {
                setIsToggled(false);
            }
        };

        document.addEventListener('click', listener);

        return () => {
            document.removeEventListener('click', listener);
        };
    }, [ref, setIsToggled]);
};
